import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TypeOrmFindManyOptions } from '@wilson/base';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Partner } from '@wilson/share/interfaces';
import { Observable } from 'rxjs/dist/types';
import { stringify } from 'qs';

@Injectable({
  providedIn: 'root',
})
export class PartnershipGateway {
  protected readonly http = inject(HttpClient);
  protected readonly config = inject<ConfigOptions>(ConfigService);

  protected readonly path = 'partnerships';

  public getAll(
    options?: TypeOrmFindManyOptions,
    {
      headers,
    }: {
      headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
          };
    } = {},
  ): Observable<Partner[]> {
    const params = stringify(options, {
      arrayFormat: 'brackets',
    });

    return this.http.get<Partner[]>(
      `${this.config.host}/${this.path}?${params}`,
      { headers },
    );
  }
}
